import {
  create_customer,
  update_customer,
  delete_customer,
  recover_customer,
  query_customer_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-customer-config1';

import { onMounted, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';
import {get_gender, get_is_active, get_is_active2, getDate} from '@/utils/function';
import pinyin from 'pinyin';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'search_text',
      label: '模糊搜索',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写搜索内容',
    },
    {
      type: 'input',
      name: 'name',
      label: '会员姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写会员姓名',
    },
    {
      type: 'input',
      name: 'phone',
      label: '手机',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写手机',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '会籍门店',
      disabled: false,
      placeholder: '请选择会籍门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'input',
      name: 'code',
      label: '会员编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写会员编号',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    phone: null,
    shop_id: null,
    code: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '会员姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写会员姓名',
    },
    {
      type: 'input',
      name: 'pinyin',
      label: '拼音',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写拼音',
    },
    {
      type: 'datepicker',
      name: 'join_date',
      label: '建档日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写建档日期',
    },
    {
      type: 'radio',
      name: 'gender',
      label: '性别',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择性别',
    },
    {
      type: 'datepicker',
      name: 'birthday',
      label: '生日',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写生日',
    },
    {
      type: 'input',
      name: 'phone',
      label: '电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写电话',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '会籍门店',
      disabled: false,
      placeholder: '请选择会籍门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },

    {
      type: 'remoteselect',
      name: 'hk_type_id',
      label: '获客方式',
      disabled: false,
      placeholder: '请选择获客方式',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-hktype',
    },
    {
      type: 'remoteselect',
      name: 'adviser_id',
      label: '所属顾问',
      disabled: false,
      placeholder: '请选择所属顾问',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入会员姓名' }],
    pinyin: [{ required: true, message: '请输入拼音' }],
    join_date: [{ required: true, message: '请填输入建档日期' }],
    gender: [{ required: true, message: '请选择性别' }],
    birthday: [{ required: true, message: '请填输入出生日期' }],
    phone: [{ required: true, pattern: /^1[3456789]\d{9}$/, message: '请填输入正确手机' }],
    shop_id: [{ required: true, message: '请填输入会籍' }],
    hk_type_id: [{ required: true, message: '请输入获客方式' }],
    adviser_id: [{ required: true, message: '请选择所属顾问' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    join_date: null,
    gender: null,
    birthday: null,
    phone: null,
    adviser_id: null,
    shop_id: null,
    hk_type_id: null,
    pinyin: null,
  }),
  watch:{
    name:(data:any)=>{
      const list = pinyin(data.name, {
        style: 4,
      });
      let str = '';
      list.forEach(item => {
        str += item;
      });
      data['pinyin'] = str;
    },
  },
};
const edit_model_config_options = {
  gender: [
    { value: 0, name: '女' },
    { value: 1, name: '男' },
  ],
};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '会员姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写会员姓名',
    },
    {
      type: 'datepicker',
      name: 'join_date',
      label: '建档日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写建档日期',
    },
    {
      type: 'radio',
      name: 'gender',
      label: '性别',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择性别',
    },
    {
      type: 'datepicker',
      name: 'birthday',
      label: '生日',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写生日',
    },
    {
      type: 'input',
      name: 'phone',
      label: '电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写电话',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '会籍门店',
      disabled: false,
      placeholder: '请选择会籍门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'hk_type_id',
      label: '获客方式',
      disabled: false,
      placeholder: '请选择获客方式',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-hktype',
    },
    {
      type: 'remoteselect',
      name: 'adviser_id',
      label: '所属顾问',
      disabled: false,
      placeholder: '请选择所属顾问',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入会员姓名' }],
    join_date: [{ required: true, message: '请填输入建档日期' }],
    birthday: [{ required: true, message: '请填输入出生日期' }],
    phone: [{ required: true, pattern: /^1[3456789]\d{9}$/, message: '请填输入正确手机' }],
    shop_id: [{ required: true, message: '请填输入会籍' }],
    adviser_id: [{ required: true, message: '请选择所属顾问' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    join_date: null,
    gender: null,
    birthday: null,
    adviser_id: null,
    phone: null,
    shop_id: null,
    hk_type_id: null,
  }),
};
const update_model_config_options = {
  gender: [
    { value: 0, name: '女' },
    { value: 1, name: '男' },
  ],
};

const titleList = {
  title: '会员管理',
  addModalTitle: '新建会员',
  updateTitle: '修改会员',
  is_create: true, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    customer_id: 'id',
  },
  delete: {
    customer_id: 'id',
  },
  recover: {
    customer_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    customer_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '会员编号',
    width: 150,
    dataIndex: 'code',
    fixed: 'left',
    checked: true,
  },
  {
    title: '会员姓名',
    width: 150,
    dataIndex: 'name',
    fixed: 'left',
    checked: true,
  },
  {
    title: '会籍门店',
    width: 150,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '所属顾问',
    width: 150,
    dataIndex: 'adviser__name',
    checked: true,
  },
  {
    title: '等级名称',
    width: 150,
    dataIndex: 'grade__name',
    checked: true,
  },
  {
    title: '性别',
    width: 150,
    dataIndex: 'gender',
    checked: true,
    slots: { customRender: 'gender' },
    filterMultiple: true,
    filters: [
      { text: '全部', value: '' },
      { text: '0', value: '女' },
      { text: '1', value: '男' },
    ],
    content: (record: any, text: any) => {
      return get_gender(text);
    },
  },
  {
    title: '电话',
    width: 150,
    dataIndex: 'phone',
    checked: true,
  },
  {
    title: '生日',
    width: 150,
    dataIndex: 'birthday',
    checked: true,

    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '建档日期',
    width: 150,
    dataIndex: 'join_date',
    checked: true,

    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '获客方式',
    width: 150,
    dataIndex: 'hk_type__name',
    checked: true,
  },
  {
    title: '微信昵称',
    width: 150,
    dataIndex: 'persontocostom__name',
    slots: { customRender: 'wechat_name' },
    checked: true,
  },
  {
    title: '数据核对',
    dataIndex: 'is_checked',
    width: 110,
    cellComponent: 'boolean',
    name1: '已完成',
    name2: '',
    checked: true,
    content: (record: any, text: any) => {
      const dict: any = {
        true: '已完成',
        false: '',
      };
      return dict[text];
    },
  },
  {
    title: '操作',
    width: 220,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  { type: 'custom', slotName: 'gender', field_0: '女', field_1: '男' },
  { type: 'custom', field_true: '可用', field_false: '作废' },
  {
    type: 'custom',
    slotName: 'is_checked',
    field_true: '已完成',
    field_false: '',
  },
);

export default () => {
  const route = useRoute();
  search_config.model.search_text = route.query.q;
  onMounted(() => {
    watch(
      () => route.query,
      () => {
        if (route.path == '/business_manage/mjstore-customer' && route.query.q) {
          // search_config.model.search_text = route.query.q;
          event_obj.emit('refresh_search', { search_text: route.query.q });
        }
      },
    );
  });
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_list,
    addData: create_customer,
    updateData: update_customer,
    removeData: delete_customer,
    recoverData: recover_customer,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
